import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { X } from "react-feather";
import { TabService } from "../../../../services/sale/tabService.ts";

const PosViewTabModal = ({ isOpen, onClose }) => {
  const [tabs, setTabs] = useState([]);
  const [activeTab, setActiveTab] = useState("myTabs");
  const [search, setSearch] = useState("");

  const staffId = Number(localStorage.getItem("pos_staff_id")) || 0;

  useEffect(() => {
    if (isOpen) {
      loadTabs();
    }
  }, [isOpen]);

  const loadTabs = async () => {
    try {
      const result = await TabService.getAllTabs();
      setTabs(result ?? []);
    } catch (err) {
      console.error("Failed to load tabs", err);
      setTabs([]);
    }
  };

  if (!isOpen) return null;

  // Filter per tab type + search
  const filteredTabs = tabs
  .filter((t) => {
    if (activeTab === "myTabs") return t.FK_StaffID === staffId;
    if (activeTab === "voided") return t.IsVoided === true;
    if (activeTab === "paid") return t.IsPaid === true;
    if (activeTab === "closed") return t.IsClosed === true;
    return true;
  })
  .filter((t) => {
    const term = search.toLowerCase();
    const name = (t.TabName ?? "").toLowerCase();
    const account = (t.AccountName ?? "").toLowerCase();

    return name.includes(term) || account.includes(term);
  });

  return (
    <div
      className="modal fade show d-block"
      style={{ backgroundColor: "rgba(0,0,0,0.6)", zIndex: 1055 }}
    >
      <div
        className="modal-dialog modal-md modal-dialog-centered"
        style={{ maxWidth: "750px", width: "100%" }}
      >
        <div className="modal-content">
          {/* HEADER */}
          <div className="modal-header p-4 border-0">
            <h5 className="modal-title">Tabs</h5>
            <button className="btn" onClick={onClose}>
              <X size={20} />
            </button>
          </div>

          {/* BODY */}
          <div className="modal-body p-4">
            {/* TABS */}
            <ul className="nav nav-tabs mb-3" role="tablist">
              {[
                { key: "myTabs", label: "My Tabs" },
                { key: "voided", label: "Voided" },
                { key: "paid", label: "Paid" },
                { key: "closed", label: "Closed" },
              ].map((tab) => (
                <li key={tab.key} className="nav-item" role="presentation">
                  <button
                    type="button"
                    className={`nav-link ${activeTab === tab.key ? "active" : ""
                      }`}
                    onClick={() => setActiveTab(tab.key)}
                  >
                    {tab.label}
                  </button>
                </li>
              ))}
            </ul>

            {/* SEARCH */}
            <div className="table-top mb-3">
              <div className="search-set w-100 search-order">
                <div className="search-input w-100">
                  <input
                    type="text"
                    placeholder="Search"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    className="form-control form-control-sm formsearch w-100"
                  />
                  <button type="button" className="btn btn-searchset">
                    <i className="feather-search" />
                  </button>
                </div>
              </div>
            </div>

            {/* TAB LIST */}
            <div
              className="order-body"
              style={{ maxHeight: "60vh", overflowY: "auto" }}
            >
              {filteredTabs.length === 0 && (
                <p className="text-muted text-center py-3">No tabs found</p>
              )}

              {filteredTabs.map((t) => (
                <div
  key={t.TabID}
  className="default-cover p-4 mb-4"
  style={{
    border: "1px solid #ddd",
    borderRadius: "8px",
    boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
    background: "#fff"
  }}
>
                  <div className="d-flex align-items-center justify-content-between mb-4">
  {/* LEFT: Tab Name */}
  <span
    className="badge bg-secondary d-inline-block"
    style={{ fontSize: "0.9rem", padding: "6px 10px" }}
  >
    {t.TabName ?? t.AccountName}
  </span>

  {/* RIGHT: Table Number */}
  {t.TableNumber && (
    <span
      className="badge bg-secondary d-inline-block"
      style={{ fontSize: "0.9rem", padding: "6px 10px" }}
    >
      {t.TableNumber}
    </span>
  )}
</div>


                  <div className="row">
                    <div className="col-sm-12 col-md-6 record mb-3">
                      <table >
                        <tbody>
                          <tr>
                            <td>Cashier</td>
                            <td className="colon">:</td>
                            <td>{t.StaffName}</td>
                          </tr>
                          <tr>
                            <td>Customer</td>
                            <td className="colon">:</td>
                            <td>{t.AccountName}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                   <div className="col-sm-12 col-md-6 record mb-3">
  <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "6px" }}>
    <span style={{ whiteSpace: "nowrap" }}>
      Date <span style={{ margin: "0 4px" }}>:</span>
    </span>

    <span style={{ whiteSpace: "nowrap" }}>
      {t.DateOpened}
    </span>
  </div>

  <div style={{ display: "flex", justifyContent: "space-between" }}>
    <span style={{ whiteSpace: "nowrap" }}>
      Total <span style={{ margin: "0 4px" }}>:</span>
    </span>

    <span style={{ whiteSpace: "nowrap", textAlign: "right" }}>
      <span className="text-success fw-bold me-4">
        Paid: R{(t.AmountPaid ?? 0).toFixed(2)}
      </span>
      <span className="text-danger fw-bold">
        Due: R{(t.AmountDue ?? 0).toFixed(2)}
      </span>
    </span>
  </div>
</div>


                  </div>

                  {/* Blank description area to match template */}
                  <div className="p-4 bg-light rounded mb-4" />

                  <div className="btn-row d-flex justify-content-between">
                    <button
                      type="button"
                      className="btn btn-info flex-fill mx-1"
                    >
                      Open
                    </button>
                    <button
                      type="button"
                      className="btn btn-danger flex-fill mx-1"
                    >
                      Products
                    </button>
                    <button
                      type="button"
                      className="btn btn-success flex-fill mx-1"
                    >
                      Print
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
          {/* /BODY */}
        </div>
      </div>
    </div>
  );
};

PosViewTabModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default PosViewTabModal;
